module.exports = __webpack_public_path__ + "img/ajax-loader.c5cd7f53.gif";